import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';
import toast from 'react-hot-toast';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuth = async () => {
      const token = searchParams.get('token');
      const redirect = searchParams.get('redirect') || '/dashboard';
      
      if (token) {
        try {
          await login(token);
          navigate(redirect);
        } catch (error) {
          console.error('Login error:', error);
          toast.error('Authentication failed. Please try again.');
          navigate('/');
        }
      } else {
        toast.error('Authentication failed. Please try again.');
        navigate('/');
      }
    };
    
    handleAuth();
  }, [searchParams, login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-discord-darkest">
      <div className="text-center">
        <LoadingSpinner size="xl" />
        <p className="mt-4 text-discord-light">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
